module.exports = __webpack_public_path__ + "static/img/about.077a6e28.png";